/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WorkType = {
    WORK: 'WORK',
    PROBATION: 'PROBATION'
} as const;
export type WorkType = typeof WorkType[keyof typeof WorkType];

